import { render, staticRenderFns } from "./AdvProductGallery.vue?vue&type=template&id=881676f4&"
import script from "./AdvProductGallery.vue?vue&type=script&lang=js&"
export * from "./AdvProductGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports